import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Accordion, Row, Card, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiAgent from "../../../core/api/api.agent";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import ApiPromoCode from "../../../core/api/api.promoCode";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { tools } from "../../../core/utils/tools";
import DataGridAllPrivatePromoCode from "./DataGridAllPrivatePromoCode";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import CreateOrUpdatePromoCodeModal from "./CreateOrUpdatePromoCodeModal";
import ApiPromoCategory from "../../../core/api/api.promocategory";


const Index = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [selectedPromoCode, setSelectedPromoCode] = useState()
  const [promoCodes, setPromoCodes] = useState([]);


  const [allAgentList, setAllAgentList] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  useEffect(() => {
    (async () => {
      try {
        const restAgent = await ApiAgent.getAllAgentsName();
        setAllAgentList(restAgent);
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        const agentIdFromUrl1 = searchParams.get("agentId");
        const agentIdFromUrl = !_.isEmpty(agentIdFromUrl1) ? _.toString(agentIdFromUrl1) : 0;
        const data = await ApiPromoCode.getAllPromoCodeQuery({
          promoCode: searchParams.get("promoCode"),
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          toCreatedDate: searchParams.get("toCreatedDate"),
          agentId: agentIdFromUrl, // _.toString(searchParams.get('agentId')),
          //globalSearch: searchParams.get('globalSearch'),
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          //globalSearch: location?.state?.promoCodeId
        });
        setListData(data);
        setValue("totalCount", data.totalCount);

        const promoCategoryList = await ApiPromoCategory.getAllPromoCategory();
        setPromoCodes(promoCategoryList);

        const formInputs = [
          { name: "promoCode", type: "text" },
          { name: "fromCreatedDate", type: "datePicker" },
          { name: "toCreatedDate", type: "datePicker" },
          {
            name: "agentId",
            type: "multiSelect",
            isMulti: false,
            data: restAgent.map((obj) => {
              return { id: obj.id, title: obj.companyName };
            }),
          },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
  }, [refresh]);

  function handleChangeMulti(event) {
    setValue("agentId", event);
  }
  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  const onSubmit = async (data) => {
    if (!_.isUndefined(data.promoCode) && !_.isEmpty(data.promoCode)) data.promoCode = data?.promoCode;
    if (!_.isUndefined(data.agentId) && !_.isEmpty(data.agentId)) data.agentId = data?.agentId?.value;
    if (data.fromCreatedDate !== null && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate !== null && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiPromoCode.getAllPromoCodeQuery(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/privatePromoCodeList?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت کدهای تخفیف خصوصی</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست کدهای تخفیف خصوصی ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              className="mr-2"
              onClick={() => {
                setShowCreateModal(true);
              }}
            >
              <AddCircle className="mr-1" />
               ایجاد کد تخفیف خصوصی
            </Button>
          </div>
        </div>
        {/* Start Box Header */}

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body className="pt-0">
                      <Card.Body>
                        <Row className="d-flex align-items-center">
                          <Col sm="6" xl="3" className="tb-reponsive mt-2 px-2">
                            <Controller
                              className="mt-5"
                              name="promoCode"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="کد تخفیف"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                ></TextField>
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="agentId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={allAgentList?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  placeholder="انتخاب نماینده"
                                  className="mt-5"
                                  field={field}
                                  onChange={handleChangeMulti}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder="تاریخ ورود مسافر از"
                                  onChange={(date) => {
                                    var toCreatedDate = getValues("toCreatedDate");
                                    onChange(date);
                                    if (
                                      !toCreatedDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCreatedDate).getTime())
                                    ) {
                                      // Set the value of toCreatedDate to the same as toCreatedDate
                                      setValue("toCreatedDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تاریخ ورود مسافر تا"
                                />
                              )}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" className="tb-reponsive px-2 mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                {
                  <DataGridAllPrivatePromoCode
                    data={listData}
                    callBack={callBackJustForRunUseEffect}
                    setSelectedPromoCode={setSelectedPromoCode}
                  />
                }
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
      {(!!selectedPromoCode || showCreateModal) &&
        <CreateOrUpdatePromoCodeModal
          selectedPromoCode={selectedPromoCode}
          callBack={callBackJustForRunUseEffect}
          setSelectedPromoCode={setSelectedPromoCode}
          showCreateModal={showCreateModal}
          setShowCreateModal={setShowCreateModal}
          allAgentList={allAgentList}
        />}
    </div>
  );
};

export default Index;
